import { Component, OnInit } from '@angular/core';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { firstValueFrom } from 'rxjs';
import { StaticPageUpdateDto } from 'src/app/shared/dtos/staticPage/staticPageUpdateDto';
import { PageType } from 'src/app/shared/enums/pageType';
import { StaticPageService } from 'src/app/shared/services';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-policies-kvkk',
  templateUrl: './policies-kvkk.component.html',
  styleUrls: ['./policies-kvkk.component.scss'],
})
export class PoliciesKvkkComponent implements OnInit {
  constructor(
    private staticPageService: StaticPageService,
    private notificationService: NotificationService,
    private loadingService: LoadingService
  ) {}

  PageType = PageType;

  termsAndConditions: StaticPageUpdateDto = this.emptyModel(
    PageType.TermsAndConditions
  );
  cancellationAndRefund: StaticPageUpdateDto = this.emptyModel(
    PageType.CancellationAndRefund
  );
  clarificationText: StaticPageUpdateDto = this.emptyModel(
    PageType.ClarificationText
  );
  informationTextRegardingTheProcessingOfPersonalData: StaticPageUpdateDto =
    this.emptyModel(
      PageType.InformationTextRegardingTheProcessingOfPersonalData
    );
  cookiePolicy: StaticPageUpdateDto = this.emptyModel(PageType.CookiePolicy);

  popupVisibleTermsAndConditions: boolean = false;
  popupVisibleClarificationText: boolean = false;
  popupVisibleInformationTextRegardingTheProcessingOfPersonalData: boolean =
    false;
  popupVisibleCookiePolicy: boolean = false;
  popupVisibleCancellationAndRefund: boolean = false;

  toolbarButtonOptionsTermsAndConditions: DxButtonTypes.Properties = {
    text: 'Ön İzleme',
    stylingMode: 'text',
    onClick: () => (this.popupVisibleTermsAndConditions = true),
  };

  toolbarButtonOptionsCancellationAndRefund: DxButtonTypes.Properties = {
    text: 'Ön İzleme',
    stylingMode: 'text',
    onClick: () => (this.popupVisibleCancellationAndRefund = true),
  };
  toolbarButtonOptionsClarificationText: DxButtonTypes.Properties = {
    text: 'Ön İzleme',
    stylingMode: 'text',
    onClick: () => (this.popupVisibleClarificationText = true),
  };
  toolbarButtonOptionsInformationTextRegardingTheProcessingOfPersonalData: DxButtonTypes.Properties =
    {
      text: 'Ön İzleme',
      stylingMode: 'text',
      onClick: () =>
        (this.popupVisibleInformationTextRegardingTheProcessingOfPersonalData =
          true),
    };
  toolbarButtonOptionsCookiePolicy: DxButtonTypes.Properties = {
    text: 'Ön İzleme',
    stylingMode: 'text',
    onClick: () => (this.popupVisibleCookiePolicy = true),
  };

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.getTermsAndConditions();
    this.getClarificationText();
    this.getInformationTextRegardingTheProcessingOfPersonalData();
    this.getCookiePolicy();
    this.getCancellationAndRefund();
  }

  async save() {
    this.loadingService.show();
    await this.saveTermsAndConditions();
    await this.saveClarificationText();
    await this.saveInformationTextRegardingTheProcessingOfPersonalData();
    await this.saveCookiePolicy();
    await this.saveCancellationAndRefund();
    this.notificationService.show('Başarı ile güncellendi.');
    this.loadingService.hide();
  }

  getTermsAndConditions() {
    this.staticPageService
      .getByPageType(PageType.TermsAndConditions)
      .subscribe((data) => {
        this.definationModelTermsAndConditions(data[0]);
      });
  }
  getCancellationAndRefund() {
    this.staticPageService
      .getByPageType(PageType.CancellationAndRefund)
      .subscribe((data) => {
       
        this.definationModelCancellationAndRefund(data[0]);
      
      });
  } 

  getClarificationText() {
    this.staticPageService
      .getByPageType(PageType.ClarificationText)
      .subscribe((data) => {
        this.definationModelClarificationText(data[0]);
      });
  }
  getInformationTextRegardingTheProcessingOfPersonalData() {
    this.staticPageService
      .getByPageType(
        PageType.InformationTextRegardingTheProcessingOfPersonalData
      )
      .subscribe((data) => {
        this.definationModelInformationTextRegardingTheProcessingOfPersonalData(
          data[0]
        );
      });
  }
  getCookiePolicy() {
    this.staticPageService
      .getByPageType(PageType.CookiePolicy)
      .subscribe((data) => {
        this.definationModelCookiePolicy(data[0]);
      });
  }

  async saveCancellationAndRefund() {
    if (this.cancellationAndRefund.id > 0) {
      await firstValueFrom(
        this.staticPageService.update(
          this.cancellationAndRefund.id,
          this.cancellationAndRefund
        )
      );
    } else {
      await firstValueFrom(
        this.staticPageService.create(this.cancellationAndRefund)
      );
    }
    this.getCancellationAndRefund();
  }

  async saveTermsAndConditions() {
    if (this.termsAndConditions.id > 0) {
      await firstValueFrom(
        this.staticPageService.update(
          this.termsAndConditions.id,
          this.termsAndConditions
        )
      );
    } else {
      await firstValueFrom(
        this.staticPageService.create(this.termsAndConditions)
      );
    }
    this.getTermsAndConditions();
  }
  async saveClarificationText() {
    if (this.clarificationText.id > 0) {
      await firstValueFrom(
        this.staticPageService.update(
          this.clarificationText.id,
          this.clarificationText
        )
      );
    } else {
      await firstValueFrom(
        this.staticPageService.create(this.clarificationText)
      );
    }
    this.getClarificationText();
  }
  async saveInformationTextRegardingTheProcessingOfPersonalData() {
    if (this.informationTextRegardingTheProcessingOfPersonalData.id > 0) {
      await firstValueFrom(
        this.staticPageService.update(
          this.informationTextRegardingTheProcessingOfPersonalData.id,
          this.informationTextRegardingTheProcessingOfPersonalData
        )
      );
    } else {
      await firstValueFrom(
        this.staticPageService.create(
          this.informationTextRegardingTheProcessingOfPersonalData
        )
      );
    }
    this.getInformationTextRegardingTheProcessingOfPersonalData();
  }
  async saveCookiePolicy() {
    if (this.cookiePolicy.id > 0) {
      await firstValueFrom(
        this.staticPageService.update(this.cookiePolicy.id, this.cookiePolicy)
      );
    } else {
      await firstValueFrom(this.staticPageService.create(this.cookiePolicy));
    }
    this.getCookiePolicy();
  }

  definationModelTermsAndConditions(data: any) {
    this.termsAndConditions.id = data.id;
    this.termsAndConditions.title = data.title;
    this.termsAndConditions.content = data.content;
    this.termsAndConditions.tag = data.tag;
    this.termsAndConditions.imageUrl = data.imageUrl;
    this.termsAndConditions.pageType = PageType.TermsAndConditions;
    this.termsAndConditions.metaKeyword = data.metaKeyword;
    this.termsAndConditions.metaDescription = data.metaDescription;
  }
  definationModelClarificationText(data: any) {
    this.clarificationText.id = data.id;
    this.clarificationText.title = data.title;
    this.clarificationText.content = data.content;
    this.clarificationText.tag = data.tag;
    this.clarificationText.imageUrl = data.imageUrl;
    this.clarificationText.pageType = PageType.ClarificationText;
    this.clarificationText.metaKeyword = data.metaKeyword;
    this.clarificationText.metaDescription = data.metaDescription;
  }
  definationModelCancellationAndRefund(data: any) {
    this.cancellationAndRefund.id = data.id;
    this.cancellationAndRefund.title = data.title;
    this.cancellationAndRefund.content = data.content;
    this.cancellationAndRefund.tag = data.tag;
    this.cancellationAndRefund.imageUrl = data.imageUrl;
    this.cancellationAndRefund.pageType = PageType.CancellationAndRefund;
    this.cancellationAndRefund.metaKeyword = data.metaKeyword;
    this.cancellationAndRefund.metaDescription = data.metaDescription;
  }
  definationModelInformationTextRegardingTheProcessingOfPersonalData(
    data: any
  ) {
    this.informationTextRegardingTheProcessingOfPersonalData.id = data.id;
    this.informationTextRegardingTheProcessingOfPersonalData.title = data.title;
    this.informationTextRegardingTheProcessingOfPersonalData.content =
      data.content;
    this.informationTextRegardingTheProcessingOfPersonalData.tag = data.tag;
    this.informationTextRegardingTheProcessingOfPersonalData.imageUrl =
      data.imageUrl;
    this.informationTextRegardingTheProcessingOfPersonalData.pageType =
      PageType.InformationTextRegardingTheProcessingOfPersonalData;
    this.informationTextRegardingTheProcessingOfPersonalData.metaKeyword =
      data.metaKeyword;
    this.informationTextRegardingTheProcessingOfPersonalData.metaDescription =
      data.metaDescription;
  }
  definationModelCookiePolicy(data: any) {
    this.cookiePolicy.id = data.id;
    this.cookiePolicy.title = data.title;
    this.cookiePolicy.content = data.content;
    this.cookiePolicy.tag = data.tag;
    this.cookiePolicy.imageUrl = data.imageUrl;
    this.cookiePolicy.pageType = PageType.CookiePolicy;
    this.cookiePolicy.metaKeyword = data.metaKeyword;
    this.cookiePolicy.metaDescription = data.metaDescription;
  }

  emptyModel(type: PageType): StaticPageUpdateDto {
    return {
      id: 0,
      title: '',
      content: '',
      tag: '',
      imageUrl: '',
      pageType: type,
      metaKeyword: '',
      metaDescription: '',
    };
  }

  onFileSelectedTermsAndConditions(base64: any) {
    this.termsAndConditions.selectedFileBase64 = base64;
  }
  onFileSelectedCancellationAndRefund(base64: any) {
    this.cancellationAndRefund.selectedFileBase64 = base64;
  }
  onFileSelectedClarificationText(base64: any) {
    this.clarificationText.selectedFileBase64 = base64;
  }
  onFileSelectedInformationTextRegardingTheProcessingOfPersonalData(base64: any) {
    this.informationTextRegardingTheProcessingOfPersonalData.selectedFileBase64 = base64;
  }

}
